import Logout from 'components/pages/Logout/Logout';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('registration-login');
export default buildPage(Logout, {
  fullPageWidth: true,
  metaData: {
    title: 'Logout',
    description: 'Please log in or sign up',
  },
});
